import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import type { StudioFormConfigSummary } from '~features/form-submissions/api/types';
import type { CreateFormConfigBody, UpdateFormConfigBody } from './types';

export const useCreateFormConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateFormConfigBody) => {
      const response = await baseAPI.post<StudioFormConfigSummary>(
        'forms/configs',
        body,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.FORM_CONFIGS] });
    },
  });
};

export const useUpdateFormConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      body,
    }: {
      id: string;
      body: UpdateFormConfigBody;
    }) => {
      const response = await baseAPI.patch<StudioFormConfigSummary>(
        `forms/configs/${id}`,
        body,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.FORM_CONFIGS] });
    },
  });
};
